import { FC } from "react";

interface CoachingSettingsProps {}

const CoachingSettings: FC<CoachingSettingsProps> = () => (
  <>CoachingSettings</>
);

export default CoachingSettings;
